import script from "./BVIprize.vue?vue&type=script&setup=true&lang=js"
export * from "./BVIprize.vue?vue&type=script&setup=true&lang=js"

import "./BVIprize.vue?vue&type=style&index=0&id=0ef5bf51&scoped=true&lang=scss"

import exportComponent from "D:\\Projects\\profgame\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ef5bf51"]])

export default __exports__